import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'default' | 'large';
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  size = 'default',
  className = '',
  onClick
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-xl' : 'px-8 py-4 text-lg';
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Redirigir a la página de checkout de Shopify
      window.location.href = 'https://www.calmnestguides.com/cart/44025020612694:1';
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 20px 40px rgba(232, 165, 152, 0.3)'
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.2
  }} onClick={handleClick} className={`${sizeClasses} bg-coral text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-shadow ${className}`} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-12">
      {children}
    </motion.button>;
}